import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hubspot': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M267.4 211.6C242.3 235.3 226.6 268.9 226.6 306.2 226.6 335.5 236.3 362.5 252.6 384.2L203.1 434C198.7 432.4 194 431.5 189.1 431.5 178.3 431.5 168.2 435.7 160.6 443.3 153 450.9 148.8 461.1 148.8 471.9S153 492.8 160.6 500.4C168.2 508 178.4 512 189.1 512 199.9 512 210 508.1 217.7 500.4 225.3 492.8 229.5 482.6 229.5 471.9 229.5 467.7 228.9 463.7 227.6 459.8L277.6 409.6C299.6 426.5 327 436.5 356.9 436.5 428.8 436.5 486.9 378.2 486.9 306.3 486.9 241.1 439.2 187.1 376.7 177.6V116C394.2 108.6 404.9 92.2 404.9 73.1 404.9 47 384 25.2 357.9 25.2S311.2 47 311.2 73.1C311.2 92.2 321.9 108.6 339.4 116V177.2C324.2 179.3 309.8 183.9 296.7 190.8 269.1 169.9 179.2 105.1 127.8 66 129 61.6 129.8 57 129.8 52.2 129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2 25.2 81.1 48.6 104.5 77.4 104.5 87.2 104.5 96.3 101.6 104.2 96.9L267.4 211.6zM356.9 375.2C318.8 375.2 287.9 344.3 287.9 306.2S318.8 237.2 356.9 237.2 425.9 268.1 425.9 306.2 395 375.2 356.9 375.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hubspot.js
// module id = JDnj
// module chunks = 144